import React from "react";
import useRevealOnScroll from "@/hooks/useRevealOnScroll";

// Tasteful fade/slide-in wrapper. Respects prefers-reduced-motion via the hook.
export default function Reveal({ children, className = "", style, as: Tag = "div" }) {
  const { ref, inView } = useRevealOnScroll();
  return (
    <Tag ref={ref} style={style} className={`reveal ${inView ? "in" : ""} ${className}`}>
      {children}
    </Tag>
  );
}
